// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MRmuD","title":"styles_title__q9on7","list":"styles_list__4ntrT","description":"styles_description__Wtb2n"};